import {graphql, useStaticQuery} from 'gatsby'

export interface SVGFile {
  name: string
  publicURL: string
}

export const ALL_SVG_QUERY = graphql`
  {
    allFile(filter: {extension: {eq: "svg"}}) {
      edges {
        node {
          publicURL
          name
        }
      }
    }
  }
`

/**
 * Returns the URL for an SVG icon when provided the name of the icon.
 *
 * This hook uses Gatsby's querying system to ensure at build-time that
 * any SVG referenced by a component exists. Using this hook is preferable
 * to using the `/static/` folder because of that build-time check.
 *
 * @param iconName The name of the SVG icon to get the URL for
 */
export default function useSVGPublicURL(iconName: string): string {
  const data = useStaticQuery(ALL_SVG_QUERY)
  if (iconName == 'test-file-stub') {
    return ''
  }
  const icon: SVGFile | undefined = data.allFile.edges
    .map((edge: {node: SVGFile}) => edge.node)
    .find((svg: SVGFile) => svg.name == iconName)
  if (!icon) {
    throw new Error(`Unable to find image file for ${iconName}`)
  }
  return icon.publicURL
}
